import {useApi} from "../Api";
import {OWRouteExceptionDetail, OWRouteExceptionDetailCopyRequest} from "../types/owRouteExceptionDetail";

export const useOWRouteExceptionDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/ow-route-exception-detail";

    function getOWRouteExceptionDetails(ancillaryExceptionId: number): Promise<OWRouteExceptionDetail[]> {
        return GET(`${PATH}/routes?ancillaryExceptionId=${ancillaryExceptionId}`);
    }

    function getOWRouteDetailsFromCopyAncillary(body: OWRouteExceptionDetailCopyRequest): Promise<OWRouteExceptionDetail[]> {
        return POST(`${PATH}/copy-route-from-ow-ancillary`, body);
    }

    function putOWRouteExceptionDetails({owRouteExceptionDetails}: { owRouteExceptionDetails: OWRouteExceptionDetail[] }): Promise<OWRouteExceptionDetail[]> {
        return PUT(`${PATH}/update-routes`, owRouteExceptionDetails);
    }

    return {
        getOWRouteExceptionDetails,
        getOWRouteDetailsFromCopyAncillary,
        putOWRouteExceptionDetails
    };
};